// extracted by css-extract-rspack-plugin
export default {"Wrapper":"XHmXP","Main":"qzpQu","AdminPeopleApp":"NDqEa","Sidebar":"u6vXz","Content":"uoJCO"};